import BaseModal from 'components/CommonComponents/BaseModal'
import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'
import { IPop } from 'constants/interfaces'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import colors from 'constants/colors'

interface IProps {
  isOpen: boolean
  pop: IPop
  onClose: () => void
}

const SkeletonLine = ({ width, height = '12px' }: { width: string; height?: string }) => (
  <Box width={width} height={height} borderRadius="999px" bg={colors.greyLight3} />
)

export const NotificationPopPlaceholder = ({ isOpen, pop, onClose }: IProps) => {
  const isUnavailable = pop.isNotificationUnavailable

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc={false}
      overflowY="unset"
      maxWidth="32rem"
      hideCloseButton
      isShowAnimation
      headerContent={
        <Flex minH="96px" justifyContent="center" alignItems="flex-start">
          <Box
            width="86px"
            height="86px"
            borderRadius="999px"
            bg={isUnavailable ? '#EEF1F6' : colors.greyLight3}
            mt="-16px"
          />
        </Flex>
      }
      bodyContent={
        <Flex w="100%" flexDir="column" alignItems="center" px="24px">
          {isUnavailable ? (
            <>
              <Text fontSize="22px" lineHeight="28px" fontWeight={700} color="#111827" textAlign="center">
                {pop.pop_title || 'Content is no longer available'}
              </Text>
              <Text mt="12px" fontSize="15px" lineHeight="22px" color="#667085" textAlign="center">
                {pop.pop_body || 'This pop may have expired or already been acknowledged.'}
              </Text>
            </>
          ) : (
            <>
              <SkeletonLine width="58%" height="18px" />
              <Box h="18px" />
              <SkeletonLine width="92%" />
              <Box h="8px" />
              <SkeletonLine width="74%" />
              <Box h="24px" />
              <Box width="100%" height="116px" borderRadius="18px" bg="#F2F4F8" />
            </>
          )}
        </Flex>
      }
      footerContent={
        <Flex w="100%" justifyContent="center">
          <NoFocusButton
            isDisabled={!isUnavailable}
            onClick={onClose}
            w="65%"
            h="42px"
            borderRadius="999px"
            bg="#879AF2"
            color="white"
            fontWeight={700}
            opacity={isUnavailable ? 1 : 0.55}
            _hover={{ bg: '#7586F0' }}
          >
            OK
          </NoFocusButton>
        </Flex>
      }
    />
  )
}
